import React from 'react';

import { Jumbotron, Button, Carousel, Grid, Row, Col } from 'react-bootstrap';


class Home extends React.Component {

	constructor(props) {
		super(props);
		this.setActive = this.setActive.bind(this);
		this.state = {activeId:  0};
	}

	setActive(activeId) { 
		this.setState({activeId: activeId});
	}

	render() { 
		let carouselText = null;
		switch(this.state.activeId) {
			default:
			case 0: 
					carouselText = (<p >Use direct shell integration to run commands like <code>grep</code>, <code>curl</code> and <code>adb</code>. </p>);
					break;
			case 1: carouselText = (<p >Instrument your code with the <a href="https://github.com/dimitarz/splinter" target="_blank">splinter-logging-util</a> and produce control flow graphs. </p>); 
					break;
			case 2: carouselText = (<p >Group logs by field (such as Android's tag) and see the big picture patterns. </p>);
					break;
		}

		return (
			<div className="contents">
				<Jumbotron className="hero" id="jtDownload">
					
						<center><div id="callToAction">
							<h1>Splinter</h1>

							<p>Make dredging through logs great again!</p>
							
							<div id='downloadButton'>
								<Button bsSize="large" bsStyle="warning" href="http://bit.ly/1NuNXRT">Download Splinter</Button>
								<p id="versionCode">version 1.0 for macos 10.9+</p>
							</div>
						</div></center>
					
					<div className="clear"/>
				</Jumbotron>

				<div className="hero" id="jtFeature">
					<center>
						<h2>A fully featured app, with style in mind.</h2>
						{carouselText}
						<Carousel id="featureCarousel" pauseOnHover={true} interval={4000} onSelect={this.setActive}>
						    <Carousel.Item>
						      	<img width={700} height={477} alt="700x477" src="/mainscreen_op.jpg"/>
						    </Carousel.Item>
						    <Carousel.Item>
						      		<img width={700} height={477} alt="700x477" src="/graphing_op.jpg"/>
						    </Carousel.Item>
						    <Carousel.Item>
						      		<img width={700} height={477} alt="700x477" src="/grouping_op.jpg"/>
						    </Carousel.Item>
						  </Carousel>
					 </center>
				</div>

				<div className="hero" id="jtFeature2">
					<center>
						<Grid>
						    <Row>
						      <Col md={4} sm={4} lg={4} xs={12} >
						      	<img className="featureIcon" alt="graph" src="/network.svg" height={60}/>
						      	<h4>Control Flow Graphs</h4>
						      	<p>
						      		Instrumenting your code with <a href="https://github.com/dimitarz/splinter" target="_blank">splinter-logging-util</a> gets you free latency tracking, method paramters and a communication diagram.
						      	</p>
						      </Col>
						      <Col md={4} sm={4} lg={4} xs={12} >
						      	<img className="featureIcon" alt="formats" src="/binders.svg" height={60}/>
						      	<h4>Supported Formats</h4>
						      	<p>
						      		In addition to coming bundled with <code>log4j</code>, <code>logcat</code>, and <code>CLF</code>, entirely custom logs definitions are also supported.
						      	</p>
						      </Col>
						      <Col md={4} sm={4} lg={4} xs={12} >
						      	<img className="featureIcon" alt="command line" src="/pc-graphs.svg" height={60}/>
						      	<h4>Command Line Interface</h4>
						      	<p> 
						      		Execute most shell commands, such as <code>grep</code> and <code>adb</code> right from inside Splinter. Piping output is supported.
						      	</p>
						      </Col>
						    </Row>
						</Grid>
					</center>
				</div>
			</div>
			);
	}
}

export default Home;


// WEBPACK FOOTER //
// ./src/Home.js